// La chasse aux économies : examiner une dépense pour la réduire, pour toujours.
import { EXPENSES } from '../content/expenses';
import { futureValueOfMonthly, round2 } from '../engine/finance';
import { fmtEur } from '../engine/format';
import { t } from '../engine/i18n';
import type { ExpenseId, GameState } from '../engine/state';
import { addJournal, addWellbeing } from './actions';
import { spendEnergy } from './work';

export const PROJECTION_RATE = 0.07;
export const PROJECTION_YEARS = 30;

export function examine(state: GameState, id: ExpenseId): void {
  const expense = state.expenses[id];
  const hunt = EXPENSES[id].hunt;
  if (!expense || !hunt || expense.optimized || expense.examined >= hunt.clicks) return;
  if (!spendEnergy(state)) return;
  expense.examined += 1;
}

export function applySaving(state: GameState, id: ExpenseId, optionId: string): void {
  const expense = state.expenses[id];
  const hunt = EXPENSES[id].hunt;
  if (!expense || !hunt || expense.optimized || expense.examined < hunt.clicks) return;
  const option = hunt.options.find((item) => item.id === optionId);
  if (!option || (option.available && !option.available(state))) return;
  const before = expense.amount;
  if (option.applyTo) option.applyTo(state);
  else if (option.apply) expense.amount = round2(Math.max(0, option.apply(before)));
  expense.optimized = true;
  expense.saved = round2(before - expense.amount);
  if (option.wellbeing) addWellbeing(state, option.wellbeing);
  addJournal(state, 'journal.saving', {
    label: t(EXPENSES[id].label),
    before: fmtEur(before),
    after: fmtEur(expense.amount),
  });
}

/** Ce que vaudrait une économie mensuelle investie pendant trente ans. */
export function savingValue(monthly: number): number {
  return futureValueOfMonthly(monthly, PROJECTION_RATE, PROJECTION_YEARS);
}

export function totalSaved(state: GameState): number {
  return Object.values(state.expenses).reduce((sum, expense) => sum + (expense?.saved ?? 0), 0);
}
